export function debugLog(scope, message, extra) {
    const time = new Date().toLocaleString('de-de', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        fractionalSecondDigits: 3,
    });
    const args = [`${time} [${scope}] ${message}`];
    if (extra)
        args.push(extra);
    console.log(...args);
}
